define('home/views/PostCollectionView',[
    'home/views/common/FetchableCollectionView',
    'home/views/PostView',
], function (
    FetchableCollectionView,
    PostView
) {
    'use strict';

    return FetchableCollectionView.extend({
        itemView: PostView,
    });
});

